import { globalFocusKey } from "@/config/focus-key";

export const playerControlsFocusKeys = {
  component: globalFocusKey.playerControls,
  toggle: globalFocusKey.playerControls + ".toggle",
  seekbar: globalFocusKey.playerControls + ".seekbar",
};
